<template>
	<div>
		<div class="img-color-overlay">
			<div class="home-v-img">
            <div class="container">
              <div class="row section-separator">
                <div class="section-title text-center col-sm-12">
                  <!--<h2>Skills</h2>-->
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="mh-skills-inner">
                    <div class="mh-professional-skill wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.3s">
                      <h3>{{ $t('skills.technicalSkills') }}</h3>
                      <div class="each-skills">
                        <div class="candidatos" v-for="(skill, i) in technicalSkills">
                            <div class="parcial">
                                <div class="info">
                                    <div class="nome">{{ skill.name }}</div>
                                    <div class="percentagem-num">{{ skill.percentage + '%' }}</div>
                                </div>
                                <div class="progressBar">
                                    <div class="percentagem" :style="{ width: skill.percentage + '%' }"></div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="mh-professional-skills wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s">
                    <h3>{{ $t('skills.professionalSkills') }}</h3>
                    <ul class="mh-professional-progress">
                        <li v-for="(skill, i) in professionalSkills" :key="i">
                            <div class="mh-progress mh-progress-circle" :data-progress="skill.percentage"></div>
                            <div class="pr-skill-name">{{ skill.name }}</div>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
		</div>
	</div>
</template>
<script>
export default {
    data(){
        return {
            technicalSkills: [
                { name: 'Java', percentage: 99 },
                { name: 'Vue.js', percentage: 90 },
                { name: 'JavaScript', percentage: 90 },
                { name: 'MySQL', percentage: 85 },
                { name: 'Redis', percentage: 85 },
                { name: 'Next.js', percentage: 85 },
                { name: 'TypeScript', percentage: 85 },
                { name: 'Linux', percentage: 85 },
                { name: 'Web3', percentage: 80 }
            ],
            professionalSkills: [
                { name: this.$t('skills.projectManagement'), percentage: 99 },
                { name: this.$t('skills.creativity'), percentage: 95 },
                { name: this.$t('skills.teamWork'), percentage: 90 },
                { name: this.$t('skills.communication'), percentage: 90 },
            ]
        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {

    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Skill.vue